module.exports = __webpack_public_path__ + "static/media/testimonialAvatar.7bd998a9.png";